import { Permission } from '../../../auth/auth.model';
import { DisplayControls } from '../../core/model/form/display-controls.model';
import { GrantStatusType } from '../../core/model/grant-status-type.model';
import { TemplatePermission } from '../../core/model/template/template-permission.model';

export function updateDisplayControls(
    overallPermissions: TemplatePermission[],
): DisplayControls {
    const displayControls: DisplayControls = {};

    if (
        overallPermissions?.some(
            (e) =>
                e.permissionId === Permission.EVALUATION_VIEW_MANAGER &&
                e.grantStatusTypeId === GrantStatusType.GRANTED,
        )
    ) {
        displayControls.displayManager = true;
    }

    if (
        overallPermissions?.some(
            (e) =>
                e.permissionId === Permission.EVALUATION_VIEW_EVALUATOR &&
                e.grantStatusTypeId === GrantStatusType.GRANTED,
        )
    ) {
        displayControls.displayEvaluator = true;
    }

    if (
        overallPermissions?.some(
            (e) =>
                e.permissionId === Permission.EVALUATION_CONTACT_LENGTH &&
                e.grantStatusTypeId === GrantStatusType.GRANTED,
        )
    ) {
        displayControls.displayContactLength = true;
    }

    if (
        overallPermissions?.some(
            (e) =>
                e.permissionId === Permission.EVALUATION_QUEUE &&
                e.grantStatusTypeId === GrantStatusType.GRANTED,
        )
    ) {
        displayControls.displayQueue = true;
    }

    return displayControls;
}
